import { render } from "./Chapter8.vue?vue&type=template&id=428082b0"
import script from "./Chapter8.vue?vue&type=script&lang=js"
export * from "./Chapter8.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__